<button type="button" class="btn btn-primary d-none" id="editTaskItemSliderModalBtn" data-toggle="modal" data-target="#editTaskItemSliderModal"> </button>

<!-- EDIT TASK MODAL -->
<div class="modal fade" id="editTaskItemSliderModal" tabindex="-1" role="dialog" aria-labelledby="editTaskItemSliderModalLabel">
    <div class="modal-dialog modalSlider" role="document">
        <div class="modal-content" *ngIf="!loading">
            <div *ngIf="!!item && !!item.id">
                <div class="modal-header">
                    <h5 class="modal-title mt-3" id="editTaskItemSliderModalLabel">{{ item.subject }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="editTaskItemSliderModalCloseBtn">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="hero-icon closeBtn">
                            <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
                <div id="editTaskModalBody" class="modal-body" style="overflow-y: auto;" *ngIf="!toBeDeleted">
                    <div class="d-flex justify-content-between flex-wrap gap-3">
                        <button class="btn btn-primary mr-1" (click)="updateStatus(true, false)" *ngIf="item.status.id != '8a7883dd-21b7-41ee-9e6e-b0e11992eb18'">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                            {{ 'Tasks.MarkAsClosed' | translate }}
                        </button>
                        <button class="btn btn-primary mr-1" (click)="updateStatus(true, true)" *ngIf="item.status.id != '8a7883dd-21b7-41ee-9e6e-b0e11992eb18' && !item.recurrance">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                            {{ 'Tasks.MarkAsClosedAndCreateNew' | translate }}
                        </button>
                        <button class="btn btn-warning mr-1" (click)="cancelTask()" *ngIf="item.status.id != '8a7883dd-21b7-41ee-9e6e-b0e11992eb18'">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            {{ 'Tasks.Cancelled' | translate }}
                        </button>
                        <button class="btn btn-success" (click)="updateStatus(false, false)" *ngIf="item.status.id == '8a7883dd-21b7-41ee-9e6e-b0e11992eb18'">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                            </svg>
                            {{ 'Activity.Done' | translate }}
                        </button>
                        <button class="btn btn-secondary" *ngIf="item.caseId && !case && !item.offerId" (click)="goToCase(item.caseId)" data-dismiss="modal">
                            {{ 'Buttons.GoToCase' | translate}}
                        </button>
                        <button class="btn btn-secondary" *ngIf="item.offerId && !case" (click)="goToOffer(item.offerId)" data-dismiss="modal">
                            {{ 'Buttons.GoTo' | translate}} {{ ('Word.Document' | translate) | lowercase }}
                        </button>
                        <button class="btn btn-secondary" (click)="registerTime = !registerTime;resetTimeRegisters();" *ngIf="hasTimeRegistry">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="hero-icon">
                                <path d="M9 4V9H12.75M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z" stroke="#0F172A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            {{ 'Task.TimeRegistration' | translate}}
                        </button>
                    </div>
                    <div *ngIf="missingImages" class="text-danger text-center mt-3">{{ 'ErrorMessage.Image' | translate }}</div>
                    <div class="card card-shadow mt-3" [ngClass]="registerTime ? 'd-flex' : 'd-none'" *ngIf="newTimeSpent">
                        <div class="card-header borderless"><div class="card-title">{{ 'Task.NewTimeRegistration' | translate }}</div></div>
                        <div class="card-body d-flex flex-column" >
                            <div class="w-100 d-flex">
                                <div class="w-50 pr-3">
                                    <div class="text-muted">{{ 'CasesDetails.User' | translate }}</div>
                                    <select class="form-control" [(ngModel)]="newTimeSpent.stakeholderId">
                                        <option value="{{user.userId}}" *ngFor="let user of users">{{ user.name }}</option>
                                    </select>
                                </div>
                                <div class="w-50 pl-3">
                                    <div class="text-muted">{{ 'Standard.PriceGroup' | translate }}</div>
                                    <select class="form-control" [(ngModel)]="newTimeSpent.priceGroupId">
                                        <option value="{{ group.priceGroupId }}" *ngFor="let group of priceGroups">{{ group.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="w-100 mt-3">
                                <div class="text-muted">{{ 'Standard.Day' | translate }}</div>
                                <div class="input-group">
                                    <input type="text"
                                        name="contractRenegotiationDate"
                                        class="form-control"
                                        placeholder="{{ 'Date.SelectDate' | translate }}"
                                        bsDatepicker
                                        #newTimeStartDate="bsDatepicker"
                                        [(ngModel)]="newTimeSpentStart.date"
                                        [bsConfig]="bsConfig"
                                        (bsValueChange)="newTimeSpentStart.setMyDate($event)">
                                    <div class="input-group-append">
                                      <button type="button" class="btn btn-secondary outsideBorder" (click)="newTimeStartDate.toggle()">
                                        <i class="far fa-calendar-alt"></i>
                                      </button>
                                  </div>
                                </div>
                            </div>
                            <div class="w-100 d-flex mt-3">
                                <div class="w-50 d-flex flex-column gap-1 pr-3">
                                    <div class="text-muted">{{ 'Standard.StartTime' | translate }}</div>
                                    <select class="form-control" [ngModel]="newTimeSpentStart.time" (change)="newTimeSpentStart.changeTime($event.target.value)">
                                        <option value="{{t}}" *ngFor="let t of newTimeSpentStart.dueTimes">{{ t }}</option>
                                    </select>
                                </div>
                                <div class="w-50 d-flex flex-column gap-1">
                                    <div class="text-muted">{{ 'Standard.EndTime' | translate }}</div>
                                    <select class="form-control" [ngModel]="newTimeSpentStop.time" (change)="newTimeSpentStop.changeTime($event.target.value)">
                                        <option value="{{t}}" *ngFor="let t of newTimeSpentStop.dueTimes">{{ t }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="w-100 mt-3">
                                <textarea class="form-control" cols="30" rows="10" [(ngModel)]="newTimeSpent.description" placeholder="{{ 'Asset.Remark' | translate }}"></textarea>
                            </div>
                            
                        </div>
                        <div class="card-footer borderless d-flex justify-content-end gap-3">
                            <button class="btn btn-secondary" (click)="registerTime = false">{{ 'Buttons.Close' | translate }}</button>
                            <button class="btn btn-primary" [disabled]="!newTimeSpent.stakeholderId" (click)="timeRegistry()">{{ 'Buttons.Save' | translate }}</button>
                        </div>
                    </div>
                    <div class="card mt-3" *ngIf="item.customer && item.customer.customerId">
                        <div class="card-body">
                            <h4>{{ 'Standard.Customer' | translate }}</h4>
                            <div>{{ item.customer.name }}</div>
                        </div>
                    </div>
                    <div class="card mt-3">
                        <div class="card-body">
                            <div class="mt-2">
                                <h4>{{ 'Standard.Title' | translate }}</h4>
                                <input type="text" class="form-control w-100" [(ngModel)]="item.subject">
                            </div>
                            <div class="mt-3">
                                <h4>{{ 'Standard.Description' | translate }}</h4>
                                <textarea name="itemNoteNew" id="itemNoteNew" class="w-100" rows="5" [(ngModel)]="item.description" placeholder="{{ 'Standard.NoDescription' | translate }}"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-3">
                        <div class="card-body">
                            <h4>{{ 'Standard.TaskDetails' | translate }}</h4>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group d-flex" *ngIf="!!activityTypes">
                                        <label class="col-form-label">{{ 'Standard.Type' | translate }}</label>
                                        <div class="col pr-0">
                                            <select class="form-control form-control-dropdown" [(ngModel)]="item.activityType.id">
                                                <option [ngValue]="null">{{ 'Standard.NoType' | translate }}</option>
                                                <option [value]="x.id" *ngFor="let x of activityTypes">{{ x.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group d-flex">
                                        <label class="col-form-label">{{ 'Standard.DueDate' | translate }}</label>
                                        <div class="col input-group pr-0">
                                            <input type="text"
                                                class="form-control"
                                                #dueDatePicker="bsDatepicker"
                                                bsDatepicker
                                                [(ngModel)]="dueDate"
                                                [bsConfig]="bsConfig"
                                                (bsValueChange)="dateChanged($event)">
                                            <div class="input-group-append">
                                                <button type="button" class="btn btn-secondary outsideBorder" (click)="dueDatePicker.show()">
                                                    <i class="far fa-calendar-alt"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group d-flex">
                                        <label class="col-form-label">{{ 'Standard.Time' | translate }}</label>
                                        <div class="col pr-0">
                                            <select class="form-control" [(ngModel)]="dueTime">
                                                <option [ngValue]="null">{{ 'Standard.NothingSpecified' | translate }}</option>
                                                <option *ngFor="let x of dueTimes" value="{{ x }}">{{ x }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group d-flex" *ngIf="!taurus">
                                        <label class="col-form-label">{{ 'Standard.Duration' | translate }}</label>
                                        <div class="col pr-0">
                                            <select class="form-control" [(ngModel)]="duration">
                                                <option [ngValue]="null">{{ 'Standard.NothingSpecified' | translate }}</option>
                                                <option *ngFor="let x of durationTimes" value="{{ x }}">{{ x }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group d-flex" [ngClass]="!item.recurrance ? 'align-items-center' : 'align-items-start'">
                                        <span class="col-form-label text-muted d-flex" [ngClass]="!item.recurrance ? 'align-items-center' : 'align-items-start'">{{ 'Recurrance.AddRecurrance' | translate }}</span>
                                        <div class="col pr-0" *ngIf="!item.recurrance">
                                            <div class="form-control cursor-pointer d-flex" (click)="makeRecurrance()">
                                                <span class="pl-1">{{ 'Recurrance.NoRecurrance' | translate }}</span>
                                            </div>
                                        </div>
                                        <div class="col mb-3 pr-0" *ngIf="!!item.recurrance">
                                            <app-recurrance-calculator [date]="item.dueDateTime" [(rule)]="item.recurrance" (change)="reccuranceChange($event)"></app-recurrance-calculator>
                                        </div>
                                    </div>
                                    <div class="form-group d-flex">
                                        <label class="col-form-label">{{ 'Standard.Responsible' | translate }}</label>
                                        <div class="col pr-0">
                                            <div class="form-control ellipsis cursor-pointer d-flex">
                                                <span class="btn btn-circle" [style.backgroundColor]="findColor('rb','')" [style.color]="findColor('rc','')" *ngIf="!!item.assignedToStakeholder" style="width:2.5rem;">{{ userServer.getInitials(item.assignedToStakeholder.name) }}</span>
                                                <select class="form-control border-none" [(ngModel)]="item.assignedToStakeholder.id" (change)="exchangeResponsibleName()">
                                                    <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                                                    <option value="{{ r.key }}" *ngFor="let r of responsibles">{{ r.value }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group d-flex" *ngIf="!!priorities && !taurus">
                                        <label class="col-form-label">{{ 'Standard.Priority' | translate }}</label>
                                        <div class="col pr-0" *ngIf="item && item.priority">
                                            <select class="form-control form-control-dropdown" [(ngModel)]="item.priority.id">
                                                <option [ngValue]="null">{{ 'Standard.NoPriority' | translate }}</option>
                                                <option [value]="x.priorityId" *ngFor="let x of priorities">{{ x.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-3" *ngIf="hasTimeRegistry && timeSpent && timeSpent.length">
                        <div class="card-header">
                            <h4>{{ 'Task.TimeRegistration' | translate }}</h4>
                        </div>
                        <div class="card-body">
                            <table aria-label="Time Registrations">
                                <thead class="d-none"><th></th></thead>
                                <tbody>
                                    <tr class="border" *ngFor="let time of timeSpent" (click)="editTime(time)">
                                        <td class="d-flex align-items-center gap-3 p-3">
                                            <div class="badge round btn-{{findUser(time.stakeholder?.name)}}">{{ findUser(time.stakeholder?.name) }}</div>
                                            <div class="ellipsis">{{ time.stakeholder?.name }}</div>
                                        </td>
                                        <td>{{ getTimeLength(time) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer d-flex justify-content-end">
                            <div class="d-flex align-items-center" (click)="registerTime = !registerTime;resetTimeRegisters();">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                    </svg>
                                <span>{{ 'Task.NewTimeRegistration' | translate }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-3" *ngIf="!!property">
                        <div class="card-body">
                            <h4>{{ 'Properties.Property' | translate }}</h4>
                            <div class="row">
                                <div class="col-8">
                                    <div class="form-group d-flex" *ngIf="!!property.number">
                                        <span class="form-control d-flex">{{ property.number }}</span>
                                    </div>
                                    <div class="form-group d-flex">
                                        <label class="col-form-label">{{ 'Standard.Address' | translate }}</label>
                                        <span class="taskTextForm">{{ !!propertyAddress ? propertyAddress : ('Standard.NoAddress' | translate) }}</span>
                                    </div>
                                </div>
                                <div class="col-4 pl-0 m-auto" *ngIf="!!property.image">
                                    <img src="https://jubloapi.azure-api.net/api/shared/attachments/{{ property.image }}" alt="{{ property.name }}" class="propertyImg">
                                </div>
                            </div>
                        </div>
    
                    </div>
                    <div class="card mt-3">
                        <div class="card-body">
                            <h4>{{ 'Standard.Remark' | translate }}</h4>
                            <textarea name="itemNoteNew" id="itemNoteNew" class="w-100" rows="5" [(ngModel)]="item.note" placeholder="{{ 'Standard.NoNotes' | translate }}"></textarea>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body mt-3">
                            <h4>{{ 'Standard.Files' | translate }}</h4>
                            <button type="button" class="btn btn-primary mr-sm-0 mt-1 mb-3 animateButton" (click)="editTaskImageUploader.click()" appImageDropper (imgDrop)="imgDrop($event)">
                                <span><i class="fas fa-plus"></i></span> {{ 'Buttons.DragAndDropFiles' | translate }} 
                            </button>
                            <file-thumbs class="mt-5" [files]="item.files" (modal)="openViewModal($event)" [options]="{restrictViewModal:false}"></file-thumbs>
                        </div>
                    </div>
                </div>
                <div class="modal-footer d-flex justify-content-between align-items-center" *ngIf="!toBeDeleted">
                    <button class="btn btn-secondary" data-dismiss="modal" (click)="updateTask()">{{ 'Buttons.SaveExit' | translate }}</button>
                    <button class="btn btn-danger" (click)="toBeDeleted = true" *ngIf="canDeleteTask">{{ 'Buttons.Delete' | translate }}</button>
                </div>
                <!-- DELETE TASK -->
                <div class="modal-body text-center mt-5" style="overflow-y: auto;" *ngIf="toBeDeleted">
                    <h3>{{ 'Standard.ConfirmDelete' | translate }} {{ 'Standard.TheActivity' | translate | lowercase }}?</h3>
                </div>
                <div class="modal-footer d-flex justify-content-between align-items-center" *ngIf="toBeDeleted">
                    <button class="btn btn-secondary" (click)="toBeDeleted = false">{{ 'Buttons.Back' | translate }}</button>
                    <button class="btn btn-danger" data-dismiss="modal" (click)="deleteTask()">{{ 'Buttons.Delete' | translate }}</button>
                </div>
            </div>
        </div>
        <!-- LOADING-->
        <div class="modal-content" *ngIf="loading">
            <div class="modal-body text-center">
                {{ 'Standard.Loading' | translate }}
            </div>
        </div>
    </div>
</div>

<input #editTaskImageUploader type="file" hidden multiple (change)="imgDrop($event.target.files)" />

<button id="editTaskViewFileModalOpener" data-toggle="modal" data-target="#editTaskViewFileModal" hidden></button>

<div id="editTaskViewFileModal" class="modal fade">
    <div class="modal-dialog modal-xl">
        <div class="modal-content" *ngIf="!!item && !!item.files && !!item.files.length">
            <div class="modal-header" *ngIf="viewFile">
                <h5 class="mb-0">{{ viewFile.name }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
            <div class="modal-body" *ngIf="viewFile">
                <div class="fullSizeImage">
                    <img [style.transform]="'rotate(' + rotateImage + 'deg)'" alt="image" src="https://jubloapi.azure-api.net/api/shared/attachments/{{ viewFile.fileId }}?userId={{user.id}}" *ngIf="viewFile.extension == '.jpg' || viewFile.extension == '.jpeg' || viewFile.extension == '.png'" />
                    <app-img-heic [fileId]="viewFile.fileId" [style]="'max-height: 81vh;max-width: 100%;object-fit: contain;vertical-align: middle;color:white; font-size:2rem'" [textColor]="'white'" *ngIf="viewFile.extension == '.heic'"></app-img-heic>
                    <pdf-viewer [autoresize]="true" [zoom]="pdfZoom" [render-text]="true" [external-link-target]="'blank'" [render-text-mode]="2" *ngIf="viewFile.extension == '.pdf' || viewFile.extension == '.blob'" [src]="displayDoc" style="max-width:100%;"></pdf-viewer>
                    <div class="w-100" [ngClass]="['.xls', '.xlsx', '.pptx', '.ppt', '.doc', '.docx'].includes(viewFile.extension) ? 'd-block' : 'd-none'">
                        <ngx-doc-viewer [url]="getURL(viewFile.fileId)" viewer="office" style="width:100%;height:80vh;"></ngx-doc-viewer>
                    </div>
                    <div class="unsupportedFile" *ngIf="!['.xls', '.xlsx', '.pptx', '.ppt', '.doc', '.docx', '.pdf', '.jpg', '.jpeg', '.png', '.heic'].includes(viewFile.extension)">
                      <div class="mb-5">{{ viewFile.extension }}</div>
                      <a href="https://jubloapi.azure-api.net/api/shared/attachments/{{ viewFile.fileId }}" target="_blank">{{ 'Images.ImageTypeNotSupported' | translate }}</a>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-center" *ngIf="viewFile">
                <div class="card w-50">
                    <div class="card-header d-flex flex-between">
                        <div class="text-bold ellipsis">{{ viewFile.name }}</div>
                        <div class="text-muted text-right" style="min-width:5rem;">{{ indexOf(viewFile.id) }}</div>
                    </div>
                    <div class="card-footer d-flex justify-content-between position-relative">
                        <div class="position-absolute" style="top:0;left: -5rem;" *ngIf="notFirstFile(viewFile.id)" (click)="setNextViewFile(-1)">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                            </svg>
                        </div>
                        <div class="position-absolute" style="top:0;right: -5rem;" *ngIf="notLastFile(viewFile.id)" (click)="setNextViewFile(1)">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                            </svg>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="d-flex gap-3" *ngIf="viewFile.extension == '.jpg' || viewFile.extension == '.jpeg' || viewFile.extension == '.png'">
                                <div (click)="rotateImage = rotateImage - 90">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
                                    </svg>
                                </div>
                                <div class="no-select">{{ 'Word.Rotate' | translate }}</div>
                                <div (click)="rotateImage = rotateImage + 90">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="hero-icon">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 15l6-6m0 0l-6-6m6 6H9a6 6 0 000 12h3" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex gap-3">
                            <button id="autoClosingViewFileModal" hidden data-dismiss="modal"></button>
                            <button class="btn btn-secondary" (click)="toBeDeleted = [viewFile.id]" data-dismiss="modal" data-toggle="modal" data-target="#areYouSureAboutDeletingModal">{{ 'Buttons.Delete' | translate }}</button>
                            <a class="btn btn-primary" href="https://jubloapi.azure-api.net/api/shared/attachments/{{ viewFile.id }}" target="_blank">{{ 'Buttons.Download' | translate }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<button type="button" class="btn btn-primary d-none" id="editTaskTimeSliderModalBtn" data-toggle="modal" data-target="#editTaskTimeSliderModal"></button>

<div class="modal fade" id="editTaskTimeSliderModal" aria-labelledby="editTaskTimeSliderModalLabel">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title mt-3" id="editTaskTimeSliderModalLabel">{{ 'Task.UpdateTimeRegistration' | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="editTaskTimeSliderModalCloseBtn">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="hero-icon closeBtn">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
            <div class="modal-body d-flex flex-column gap-3" *ngIf="editTimeSpent">
                <div class="d-flex gap-3 align-items-center">
                    <div class="flex-1 text-muted">{{ 'CasesDetails.User' | translate }}</div>
                    <select class="form-control flex-2" [(ngModel)]="editTimeSpent.stakeholder.id">
                        <option value="{{user.userId}}" *ngFor="let user of users">{{ user.name }}</option>
                    </select>
                </div>
                <div class="d-flex gap-3 align-items-center">
                    <div class="flex-1 text-muted">{{ 'Standard.PriceGroup' | translate }}</div>
                    <select class="form-control flex-2" [(ngModel)]="editTimeSpent.priceGroup.id">
                        <option value="{{ group.priceGroupId }}" *ngFor="let group of priceGroups">{{ group.name }}</option>
                    </select>
                </div>
                <div class="d-flex gap-3 align-items-center">
                    <div class="flex-1 text-muted">{{ 'Standard.Day' | translate }}</div>
                    <div class="input-group flex-2 ml-n2">
                        <input type="text"
                            name="contractRenegotiationDate"
                            class="form-control"
                            placeholder="{{ 'Date.SelectDate' | translate }}"
                            bsDatepicker
                            #editTimeStartDate="bsDatepicker"
                            [(ngModel)]="editTimeSpentStart.date"
                            [bsConfig]="bsConfig"
                            (bsValueChange)="editTimeSpentStart.setMyDate($event)">
                        <div class="input-group-append">
                          <button type="button" class="btn btn-secondary outsideBorder" (click)="editTimeStartDate.toggle()">
                            <i class="far fa-calendar-alt"></i>
                          </button>
                      </div>
                    </div>
                </div>
                <div class="d-flex gap-3 align-items-center">
                    <div class="flex-1 text-muted">{{ 'Standard.StartTime' | translate }}</div>
                    <select class="form-control flex-2" [ngModel]="editTimeSpentStart.time" (change)="editTimeSpentStart.changeTime($event.target.value)">
                        <option value="{{t}}" *ngFor="let t of editTimeSpentStart.dueTimes">{{ t }}</option>
                    </select>
                </div>
                <div class="d-flex gap-3 align-items-center">
                    <div class="flex-1 text-muted">{{ 'Standard.EndTime' | translate }}</div>
                    <select class="form-control flex-2" [ngModel]="editTimeSpentStop.time" (change)="editTimeSpentStop.changeTime($event.target.value)">
                        <option value="{{t}}" *ngFor="let t of editTimeSpentStop.dueTimes">{{ t }}</option>
                    </select>
                </div>
                <div class="d-flex gap-3 align-items-start">
                    <div class="flex-1 text-muted">{{ 'Asset.Remark' | translate }}</div>
                    <textarea class="form-control flex-2" cols="30" rows="10" [(ngModel)]="editTimeSpent.description" placeholder="{{ 'Asset.Remark' | translate }}"></textarea>
                </div>
            </div>
            <div class="modal-footer justify-content-end gap-3" *ngIf="!deleteTimeSpent">
                <button class="btn btn-secondary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
                <button class="btn btn-danger"(click)="deleteTimeSpent = true">{{ 'Buttons.Delete' | translate }}</button>
                <button class="btn btn-primary" data-dismiss="modal" (click)="updateTimeRegistration()">{{ 'Buttons.Save' | translate }}</button>
            </div>
            <div class="modal-footer justify-content-between gap-3" *ngIf="!!deleteTimeSpent">
                <button class="btn btn-secondary" (click)="deleteTimeSpent = false;">{{ 'Buttons.Back' | translate }}</button>
                <div class="d-flex align-items-center gap-3">
                    <div>{{ 'Standard.ConfirmDelete' | translate }}?</div>
                    <button class="btn btn-danger" data-dismiss="modal" (click)="deleteTaskTimeSpent()">{{ 'Buttons.Delete' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>